var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6ery7weoaa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.766 19.976H1.241c-.68 0-1.225-.55-1.225-1.225V1.225C.016.546.566 0 1.24 0h17.525c.68 0 1.226.55 1.226 1.225v17.526c0 .679-.547 1.225-1.226 1.225z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.749 6.24c0 .058 0 .113-.004.172a16.906 16.906 0 0 0-1.413-.238 2.335 2.335 0 0 0-4.667 0c-.488.062-.96.14-1.412.238-.004-.059-.004-.117-.004-.176a3.753 3.753 0 0 1 3.754-3.754 3.762 3.762 0 0 1 3.746 3.758zm-3.735 11.254c6.627-2.786 5.616-9.88 5.616-9.88-1.546-.578-3.497-.921-5.623-.921-2.127 0-4.078.343-5.624.92 0 0-1.01 7.095 5.616 9.881h.015z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.844 13.026c0 .082-.004.16-.016.238h-3.64a1.836 1.836 0 0 1 1.284-1.994 1.4 1.4 0 1 1 1.936-1.296c-.001.586-.36 1.085-.867 1.296a1.831 1.831 0 0 1 1.303 1.756z",
    fill: "#0078D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6ery7weoaa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v19.976H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.6ca70b895e991316a1051820b6056fed.svg";
export { ForwardRef as ReactComponent };